import { useCallback, useRef, useEffect } from "react";
import { useDebounceCallback } from "src/components/hookHelpers";

const SCROLL_LOAD_MORE_BOTTOM_OFFSET = 100;
const HANDLE_SCROLL_DEBOUNCE = 100;

export const useScrollBottomCheck = (onScrollBottomReached?: () => void) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const isNearBottomRef = useRef(false);

  const checkScroll = useCallback(() => {
    if (!containerRef.current || !onScrollBottomReached) return;

    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
    const scrollBottom = scrollHeight - scrollTop - clientHeight;

    // Only trigger when user is within SCROLL_LOAD_MORE_BOTTOM_OFFSET px of the bottom
    const newIsNearBottom = scrollBottom < SCROLL_LOAD_MORE_BOTTOM_OFFSET;

    // Only call onScrollBottomReached when we first reach the bottom
    if (newIsNearBottom && !isNearBottomRef.current) {
      onScrollBottomReached();
    }

    isNearBottomRef.current = newIsNearBottom;
  }, [onScrollBottomReached]);

  const debouncedCheckScroll = useDebounceCallback(
    checkScroll,
    HANDLE_SCROLL_DEBOUNCE
  );

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    container.addEventListener("scroll", debouncedCheckScroll);
    return () => container.removeEventListener("scroll", debouncedCheckScroll);
  }, [debouncedCheckScroll]);

  return containerRef;
}; 